import React from 'react'
import { compose } from 'recompose'
import { withAuthorization } from '../components/session'
import { Wrap, Title } from '../components/page/components'
import SEO from '../components/SEO'
import FocusHeader from '../components/global/focus-header'
import FocusBody from '../components/page/focus-body'
import EmailChangeForm from '../components/account/email-change-form'

const ChangeEmail = ({ authUser, location }) => {
  const backUrl =
    location.state && location.state.prevPath ? location.state.prevPath : '/'

  return (
    <Wrap>
      <SEO title="Change Email" />
      <FocusHeader
        title="Account"
        subTitle="Change Email"
        titleLink="/account"
        backUrl={backUrl}
      />
      <FocusBody>
        <Title>Change Email</Title>
        <EmailChangeForm authUser={authUser} />
      </FocusBody>
    </Wrap>
  )
}

const condition = authUser => !!authUser
const AccountWithAuth = compose(withAuthorization(condition))(ChangeEmail)
export default AccountWithAuth
